import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getRoleDescriptions } from 'api/Roles';

export const useRoleDescriptions = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(
    ['getRoleDescriptions', ...dependencies],
    () => getRoleDescriptions(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 5000,
      ...options
    }
  );
};
